<template>
  <div class="Report">
    <h1 class="title">营业执照</h1>
    <iframe
      src="https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/license.pdf"
      width="100%"
      height="700"
    />
  </div>
</template>

<script>
export default {
  name: "Report",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.Report {
  width: 100%;
  padding: 110px 100px 20px;
  .title {
    margin-bottom: 20px;
  }
}
</style>
